import { useQueryParams } from '../../utils/contexts/UrlProvider'

const reasons = {
  401: 'Você foi deslogado porque se conectou em outro dispositivo'
}

export const useUnloggedReason = () => {
  const { reason } = useQueryParams()
  return reasons[reason]
}
